module.exports = __webpack_public_path__ + "static/img/home_body_representation.0794e88.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/home_body_representation.png
// module id = 1397
// module chunks = 1